import { makeTranslationHelpers } from '@/hooks/useTranslation';

const {
  useTranslation: useValuationTranslation,
  Translation: ValuationTranslation,
} = makeTranslationHelpers('page.companyReport.valuation');

export { useValuationTranslation, ValuationTranslation };
